import { render, staticRenderFns } from "./PosCart.vue?vue&type=template&id=367fd838&scoped=true"
import script from "./PosCart.vue?vue&type=script&lang=js"
export * from "./PosCart.vue?vue&type=script&lang=js"
import style0 from "./PosCart.vue?vue&type=style&index=0&id=367fd838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367fd838",
  null
  
)

export default component.exports